var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"two-line":"","dark":""}},_vm._l((_vm.orderedMergeRequests),function(mergeRequest){return _c('div',{key:mergeRequest.id},[_c('merge-request-item',{attrs:{"mr":mergeRequest,"pipeline":_vm.getPipeline(mergeRequest)}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }